import React from 'react';
import { SendIcon, MessageCircleIcon } from 'lucide-react';
export const Contact = () => {
  return <section className="w-full py-16 px-6 md:px-10 bg-gradient-to-br from-gray-50 to-white relative overflow-hidden" data-id="element-51">
      <div className="max-w-6xl mx-auto" data-id="element-52">
        <div className="grid lg:grid-cols-[1fr_1.2fr] gap-12 items-center" data-id="element-53">
          {/* Left - Photo */}
          <div className="relative order-2 lg:order-1" data-id="element-54">
            <div className="relative w-full max-w-md mx-auto" data-id="element-55">
              <div className="absolute inset-0 bg-gradient-to-br from-[#4a9d63] to-[#3d8f5a] rounded-3xl transform rotate-2" data-id="element-56"></div>
              <div className="relative rounded-3xl overflow-hidden transform -rotate-1 shadow-2xl" data-id="element-57">
                <img src="https://uploadthingy.s3.us-west-1.amazonaws.com/juoQYMmTzhf9k9SqCjTYPD/0E73F081-CAD6-4BD2-99D4-F83DC7B6AE41.jpg" alt="Мария Бродская" className="w-full aspect-[3/4] object-cover object-center" style={{
                objectPosition: 'center 20%'
              }} data-id="element-58" />
              </div>
            </div>
          </div>
          {/* Right - Contact Options */}
          <div className="order-1 lg:order-2 space-y-10" data-id="element-59">
            <div data-id="element-60">
              <h2 className="text-4xl md:text-5xl font-bold text-gray-900 mb-3" data-id="element-61">
                Связаться со мной
              </h2>
              <h3 className="text-4xl md:text-5xl font-bold text-[#3d8f5a]" data-id="element-62">
                для записи
              </h3>
            </div>
            <div className="grid sm:grid-cols-2 gap-6" data-id="element-63">
              {/* Telegram */}
              <a href="https://t.me/mbrodskaya" target="_blank" rel="noopener noreferrer" className="group" data-id="element-64">
                <div className="bg-white rounded-3xl p-8 border-2 border-gray-200 hover:border-[#3d8f5a] transition-all hover:shadow-xl hover:scale-105 flex flex-col items-center gap-4" data-id="element-65">
                  <div className="w-16 h-16 rounded-2xl bg-gradient-to-br from-[#3d8f5a] to-[#2c5f2d] flex items-center justify-center group-hover:scale-110 transition-transform" data-id="element-66">
                    <SendIcon className="w-8 h-8 text-white" data-id="element-67" />
                  </div>
                  <div className="text-center" data-id="element-68">
                    <div className="text-sm font-semibold text-gray-900" data-id="element-69">
                      Telegram
                    </div>
                  </div>
                </div>
              </a>
              {/* WhatsApp */}
              <a href="https://wa.me/79218451514" target="_blank" rel="noopener noreferrer" className="group" data-id="element-70">
                <div className="bg-white rounded-3xl p-8 border-2 border-gray-200 hover:border-[#3d8f5a] transition-all hover:shadow-xl hover:scale-105 flex flex-col items-center gap-4" data-id="element-71">
                  <div className="w-16 h-16 rounded-2xl bg-gradient-to-br from-[#3d8f5a] to-[#2c5f2d] flex items-center justify-center group-hover:scale-110 transition-transform" data-id="element-72">
                    <MessageCircleIcon className="w-8 h-8 text-white" data-id="element-73" />
                  </div>
                  <div className="text-center" data-id="element-74">
                    <div className="text-sm font-semibold text-gray-900" data-id="element-75">
                      WhatsApp
                    </div>
                  </div>
                </div>
              </a>
            </div>
          </div>
        </div>
      </div>
      {/* Decorative element */}
      <div className="absolute bottom-0 right-0 w-96 h-96 bg-[#4a9d63] rounded-full opacity-5 blur-3xl pointer-events-none" data-id="element-76"></div>
    </section>;
};